import React from 'react';

interface Props {
  id: string;
  label: string;
  summary?: string;
  open: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

const AnalyticsDisclosure: React.FC<Props> = ({id, label, summary, open, onToggle, children}) => {
  const buttonId = `analytics-disclosure-${id}-button`;
  const panelId = `analytics-disclosure-${id}-panel`;

  return <section className="min-w-0 overflow-hidden rounded-xl bg-white shadow-sm ring-1 ring-gray-200 dark:bg-gray-900 dark:ring-gray-800">
    <h3>
      <button
        id={buttonId}
        type="button"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={onToggle}
        className="flex min-h-11 w-full items-center gap-3 px-4 py-3 text-left hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-club-blue-500 dark:hover:bg-gray-800"
      >
        <span aria-hidden="true" className={`shrink-0 transition-transform motion-reduce:transition-none ${open ? 'rotate-90' : ''}`}>&rsaquo;</span>
        <span className="min-w-0 flex-1 font-semibold text-gray-950 dark:text-white">{label}</span>
        {summary && <span aria-hidden="true" className="hidden text-xs font-medium text-gray-500 dark:text-gray-400 sm:block">{summary}</span>}
      </button>
    </h3>
    <div
      id={panelId}
      role="region"
      aria-labelledby={buttonId}
      hidden={!open}
      className="border-t border-gray-200 p-4 dark:border-gray-700"
    >
      {children}
    </div>
  </section>;
};

export default AnalyticsDisclosure;
